import { Action } from '@ngrx/store';

export const langKey = 'language';

export enum LanguageActionTypes {
    SET_BG = 'bg',
    SET_EN = 'en',
}

export class ActionLanguageBg implements Action {
    readonly type = LanguageActionTypes.SET_BG;
    constructor() { }
}

export class ActionLanguageEn implements Action {
    readonly type = LanguageActionTypes.SET_EN;
    constructor() { }
}

export type LanguageActions =
    | ActionLanguageBg
    | ActionLanguageEn;

export enum Languages {
    bg = 'bg',
    en = 'en',
}
export const initialState = Languages.bg;

export const selectorLanguage = state => state[langKey];

export function LanguageReducer(
    state = initialState,
    action: LanguageActions
): string {
    switch (action.type) {
        case LanguageActionTypes.SET_EN:
            return Languages.en;

        case LanguageActionTypes.SET_BG:
            return Languages.bg;

        default:
            return state;
    }
}
